import { __awaiter } from '../../../node_modules/tslib/tslib.es6.js';
import { styled, useMediaQuery, Snackbar, Alert } from '@mui/material';
import React__default, { useState } from 'react';
import brandclub_colors from '../../../colors/brandclubColors.js';
import { AppImage } from '../../../Components/AppImage/index.js';
import { getImageAssetUrl } from '../../../utils/assetUtils.js';
import { DIALOG_SCREEN_SIZE } from '../../../utils/constants/Constants.js';
import '../../../theme/customTheme.js';
import '../../../theme/defaultTheme.js';
import 'lodash/merge';
import { ButtonName } from '../../../theme/componentNames.js';
import '../../../utils/stringUtils.js';
import 'lodash';
import 'lodash/omitBy';
import 'lodash/isNil';
import '../../../icons/abstract/AbstractArcIcon.js';
import '../../../icons/AddCircleIcon.js';
import '../../../icons/AddCircleOutlineIcon.js';
import '../../../icons/ArrowCircleRightIcon.js';
import '../../../icons/ArrowLeftIcon.js';
import '../../../icons/ArrowRightIcon.js';
import '../../../icons/BoltIcon.js';
import '../../../icons/BookmarkStarIcon.js';
import '../../../icons/CalendarIcon.js';
import '../../../icons/CancelIcon.js';
import '../../../icons/CheckCircleIcon.js';
import '../../../icons/CheckMarkIcon.js';
import '../../../icons/ChevronDownIcon.js';
import '../../../icons/ChevronLeftIcon.js';
import '../../../icons/ChevronRightIcon.js';
import '../../../icons/ChevronUpIcon.js';
import '../../../icons/CloseIcon.js';
import '../../../icons/CopyIcon.js';
import '../../../icons/MenuIcon.js';
import '../../../icons/NotificationActiveIcon.js';
import '../../../icons/PaperPlaneIcon.js';
import '../../../icons/PendingIcon.js';
import '../../../icons/PersonIcon.js';
import '../../../icons/PlayCircleIcon.js';
import '../../../icons/RemoveCircleIcon.js';
import '../../../icons/SearchIcon.js';
import '../../../icons/SellIcon.js';
import '../../../icons/ShareIcon.js';
import '../../../icons/ShoppingBagIcon.js';
import '../../../icons/SmartphoneIcon.js';
import '../../../icons/StarIcon.js';
import '../../../icons/StarOutlineIcon.js';
import '../../../icons/SuccessCheckCircleIcon.js';
import '../../../icons/ThumbsDownIcon.js';
import '../../../icons/ThumbsUpIcon.js';
import '../../../icons/TuneIcon.js';
import '../../../icons/FourPointStarIcon.js';
import { Button } from '../../../Components/Button/Button.js';
import '../../../Components/Button/CustomDtcBagButton.js';

const ShareDialogContentContainer = styled('div', {
    label: 'ShareDialogContentContainer',
})(() => ({
    display: 'flex',
    justifyContent: 'center',
    gap: 16,
    '.platform': {
        marginTop: 10,
        width: '100%',
        maxWidth: 335,
        height: 50,
        justifyContent: 'center',
        // gap: 8,
        alignItems: 'center',
        border: `none !important`,
        transition: `background-color 0.3s ease-in-out`,
    },
    'span.platform-title': {
        [`@media (max-width: ${DIALOG_SCREEN_SIZE}px)`]: {
            fontSize: 14,
        },
    },
    '.link-copied-snackbar': {
        '.MuiPaper-root': {
            fontSize: 16,
            backgroundColor: brandclub_colors.white,
            borderRadius: 12,
            boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.16)',
            paddingTop: 0,
            paddingBottom: 0,
        },
    },
}));
const SharePage = ({ url, onShareLinkCopied }) => {
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [copyText, setCopyText] = useState('Copy Link');
    const desktopView = useMediaQuery(`(min-width:${DIALOG_SCREEN_SIZE}px)`);
    const handleCopyLink = () => __awaiter(void 0, void 0, void 0, function* () {
        navigator.clipboard.writeText(url);
        setCopyText('Link copied!');
        if (onShareLinkCopied) {
            yield onShareLinkCopied();
        }
    });
    return (React__default.createElement(ShareDialogContentContainer, null,
        React__default.createElement(Button, { variant: "solid", color: "primary", className: "platform", onClick: handleCopyLink, buttonName: ButtonName.ShareDialogButton },
            React__default.createElement("span", { className: "platform-title" }, copyText)),
        React__default.createElement(Snackbar, { open: snackbarOpen, autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, sx: (theme) => ({
                boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
                borderRadius: '7px',
                overflow: 'hidden',
                position: desktopView ? 'absolute' : 'fixed',
                bottom: `${desktopView ? '1.5' : '1'}% !important`,
                backgroundColor: theme.vars.palette.background.default,
            }), onClose: () => setSnackbarOpen(false) },
            React__default.createElement(Alert, { severity: "success", icon: React__default.createElement(AppImage, { src: getImageAssetUrl('icon_success_tick.webp'), alt: "icon-success-tick", style: { maxWidth: '20px' } }), sx: (theme) => ({
                    backgroundColor: theme.vars.palette.background.default,
                    boxShadow: 'none',
                    color: theme.vars.palette.text.primary,
                    fontSize: 12,
                    fontWeight: 600,
                }) }, "Link copied"))));
};

export { SharePage };
//# sourceMappingURL=SharePage.js.map
